module.exports = __webpack_public_path__ + "assets/img/3_1300.cde67423.jpg";